import { MinMaxElement } from "@portal/BaseComponents/Filters/Elements/MinMax/MinMaxElement";
import { FilterDropdownDown } from "@portal/BaseComponents/Filters/FilterDropdown/FilterDropdownDown";
import { CustomRangeValue } from "@portal/BaseComponents/Filters/type";
import useOpen from "@portal/hooks/useOpen";
import { disputeFiltersAtom } from "@portal/store/Filters/dipsutes/dispute-filter";
import { resetPage, tableAtom } from "@portal/store/table/table";
import produce from "immer";
import { useAtom, useSetAtom } from "jotai";
import { useMemo } from "react";

function DisputeAmountFilter() {
  const { onClose, open, toggleOpen, handleOpenChange } = useOpen({
    open: false,
  });

  const [disputeFilters, setDisputeFilters] = useAtom(disputeFiltersAtom);
  const setTable = useSetAtom(tableAtom);

  function handleHideReset() {
    return (
      !disputeFilters.filterValues.from_amount ||
      !disputeFilters.filterValues.to_amount
    );
  }

  function getFilterValuesText() {
    if (
      !disputeFilters.filterValues.from_amount ||
      !disputeFilters.filterValues.to_amount
    ) {
      return "Choose Amount";
    }
    return `${disputeFilters.filterValues.from_amount}-${disputeFilters.filterValues.to_amount}`;
  }
  function handleSubmit(value: CustomRangeValue<readonly ["min", "max"]>) {
    setDisputeFilters((filter) => {
      return produce(filter, (draft) => {
        draft.filterValues.from_amount = String(value.min);
        draft.filterValues.to_amount = String(value.max);
      });
    });
    setTable(resetPage);
    onClose();
  }

  const Content = (
    <MinMaxElement
      initialValue={{
        min: Number(disputeFilters.filterValues.from_amount),
        max: Number(disputeFilters.filterValues.to_amount),
      }}
      onSubmit={handleSubmit}
      onCancel={onClose}
    />
  );
  function handleReset() {
    setDisputeFilters((filter) => {
      return produce(filter, (draft) => {
        draft.filterValues.from_amount = undefined;
        draft.filterValues.to_amount = undefined;
      });
    });
    setTable(resetPage);
    onClose();
  }
  const filterValuesText = useMemo(getFilterValuesText, [
    disputeFilters.filterValues.from_amount,
    disputeFilters.filterValues.to_amount,
  ]);

  const hideReset = handleHideReset();
  return (
    <FilterDropdownDown
      filterBlockProps={{
        isDefault: true,
        toggleOpen,
        open,
        title: "Dispute Amount",
        filterValues: filterValuesText,
        onReset: handleReset,
        hideReset,
      }}
      filterComponent={Content}
      filterTitle={"Dispute Amount"}
      onopenChange={handleOpenChange}
    />
  );
}

export { DisputeAmountFilter };
